module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_diamond_red.41f8b9fc.png";